import { render, staticRenderFns } from "./AddAddressView.vue?vue&type=template&id=1cc3273a"
import script from "./AddAddressView.vue?vue&type=script&lang=js"
export * from "./AddAddressView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports